import { EntityBase } from './EntityBase';

export enum LUCTransferStatus {
  Draft = 0,
  Final = 1,
}

export enum LUCTransferType {
  Inbound = 0,
  Outbound = 1,
}

export interface LUCTransferResponse extends EntityBase {
  inboundDefinition?: LUCTransferDefinition;
  outboundDefinition?: LUCTransferDefinition;
  test: Test;
  inboundItemCount: number;
  outboundItemCount: number;
  dateTimeFinalized?: Date;
  status: LUCTransferStatus;
  // summary: LUCTransferSummary[];
}

interface Test {
  test: string;
}

export interface LUCTransferDefinition {
  timestamp: Date;
  transferringParty?: string;
  receivingParty?: string;
  transferringFromStationId?: string;
  transferringFromStationIataCode?: string;
  transferringToStationId?: string;
  transferringToStationIataCode?: string;
  condition?: string;
  supportingEquipment: LUCSupportingEquipment;
  demurrageCode: string;
  odlnCode: string;
  isDamaged: boolean;
  damageDescription: string;
  remarks?: string;
}

export interface LUCSupportingEquipment {
  numOfNets: number;
  numOfDoors: number;
  numOfStraps: number;
  numOfFittings: number;
}

export interface LUCTransferSummary {
  type: LUCTransferType;
  transferringParty: string;
  receivingParty: string;
  itemCount: number;
}
